export const getByUuid = (axios, payload) => axios.post(`atendimento-prontuario/get/uuid`, payload)

export const updateByUuid = (axios, payload) => axios.patch(`atendimento-prontuario`, payload)